import clsx from 'clsx';
import { useMemo, lazy, Suspense } from 'react';
import { useTranslation } from 'react-i18next';

import { useOptions, useTranslatedEntity } from '../../hooks';
import { useNomineeEntity } from '../../hooks/useNomineeEntity';
import type { NomineeType, PollType } from '../../types';
import { getPhotoByFormat } from '../../utils/l10nHelper';
import { getCompetitionId, getVideoArticleAsset } from '../../utils/utils';
import NomineeDetail from '../NomineeDetail';
import Winner from '../Winner';

import * as style from './style.module.scss';

const VideoPlayer = lazy(() => import('../VideoPlayer'));

const Nominee = ({ poll, nominee, autoplay = true }: { poll: PollType; nominee: NomineeType; autoplay?: boolean }) => {
  const match = nominee.matchDetails;
  const {
    i18n: { language },
  } = useTranslation();
  const compId = getCompetitionId(match);
  const competitionName = useTranslatedEntity(match?.competition).name;
  const { internationalName } = useNomineeEntity(nominee);
  const { appType } = useOptions();
  const isGOTS = appType === 'gots';

  const hasVideo = useMemo(() => !!getVideoArticleAsset(nominee), [nominee]);

  return (
    <div className={(style.nomineeCard, 'nominee-card')}>
      {isGOTS && (
        <div className={style.cardCompetitionName}>
          <img
            alt='competition logo'
            className={style.cardLogo}
            src={`https://img.uefa.com/imgml/uefacom/elements/logos/competitions/white/${compId}` + '.svg'}
            width='30px'
          />
          {competitionName}
        </div>
      )}
      <div className={style.mediaContainer}>
        <div className={clsx(style.videoWrapper, style.nomineeVideo)}>
          {hasVideo ? (
            <Suspense>
              <VideoPlayer
                showWinnerAnimation
                nominee={nominee}
                autoplay={autoplay}
                playOnce={nominee.isWinner}
                format='SQUARE'
              />
            </Suspense>
          ) : (
            <img
              alt={internationalName}
              className='pk-position--absolute pk-h--100 pk-w--100 '
              src={getPhotoByFormat(nominee, language, 'SQUARE')}
            />
          )}
        </div>
        <NomineeDetail poll={poll} nominee={nominee} />
      </div>
      {nominee.isWinner && <Winner />}
    </div>
  );
};

export default Nominee;
